import { type FC, useMemo } from 'react';
import type { DiscountProps } from '../../price.types';
import { cn } from '../../../../../../utils/cn';
import { Text } from '../../../../../../atoms/text';
import { getDiscountPercent } from '../../price.helper';

import styles from '../../discount.module.css';
import { PriceSizeEnum } from '../../price.enum';

export const DiscountSimple: FC<DiscountProps> = ({
    variant,
    basePrice,
    product,
    variantSize = PriceSizeEnum.SMALL,
}) => {
    const sizeClass = useMemo(() => (variantSize === PriceSizeEnum.BIG ? styles.big : styles.small), [variantSize]);

    const containerClass = useMemo(() => cn(styles.flex, variant === 'horizontal' && styles.minHeight), [variant]);

    const basePriceClass = useMemo(
        () =>
            cn(
                styles.basePrice,
                variant === 'details' && styles.detailsBasePrice,
                variant === 'horizontal' && styles.horizontalBasePrice,
                variant === 'vertical' && styles.verticalBasePrice
            ),
        [variant]
    );

    const discountClass = useMemo(
        () =>
            cn(
                styles.discount,
                variant === 'horizontal' && styles.horizontalDiscount,
                variant === 'details' && styles.detailsDiscount
            ),
        [variant]
    );

    const discountPercent = useMemo(() => `-${getDiscountPercent(product).toFixed(0)}%`, [product]);

    return (
        <div className={sizeClass}>
            <div className={containerClass}>
                <Text className={basePriceClass}>{basePrice}</Text>

                <Text className={discountClass}>{discountPercent}</Text>
            </div>
        </div>
    );
};
